const messages = {
  title: "Butik",
  description: "Välkommen till belöningsbutiken. Här kan du lösa in dina Bridgestone Plus-poäng <br/> för belöningar från olika kategorier. Utbudet av produkter <br/> uppdateras regelbundet. Vi hoppas att du gillar att surfa.",
  sort: {
    asc: "Sortera efter: Lägsta pris",
    desc: "Sortera efter: Högsta pris",
  },
  productSearchBox: {
    from: "poäng från",
    to: "poäng till",
  },
  noProducts: "Sökkriterierna gav inga resultat",
  quantity: "Antal",
  search: "Sök",
  perPage: "Objekt per sida",
  timeUnavailable: "För närvarande inte tillgänglig",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Poäng per enhet",
    pointsSum: "Summa poäng",
  },
  action: "Åtgärd",
  pointsTotal: "Totalt",
  cartRemainPoints: "Återstående poäng i varukorgen",
  shoppingCart: "Varukorg",
  emptyCart: "Varukorgen är tom.",
  attributes: "Attribut",
  selectAddressP: "Vänligen välj din leveransadress",
  orderDelivery: "Leveransadress",
  selectedProducts: "Valda produkter",
  orderSummary: "Orderöversikt",
  contactPerson: "Kontaktperson",
  selectedAddress: "Vald adress",
  order: {
    success: "Tack! Din beställning lyckades. Du får en orderbekräftelse i din inkorg inom några minuter.",
    description: "Här hittar du en översikt över dina beställningar i belöningsbutiken.",
    info: "Här hittar du en översikt över dina beställningar i belöningsbutiken.",
    date: "Orderdatum",
    number: "Ordernr",
    status: {
      created: "Skapad",
      confirm_order: "Bekräfta order",
      ready_for_shipment: "Klar för leverans",
      rejected: "Avvisad",
      processed: "Bearbetad",
      shipped: "Skickad",
      returned: "Returnerad",
      finished: "Slutförd",
    },
    anyOrder: "Inga beställningar",
    products: "Produkter",
    quantity_short: "st",
    itemRemoved: "kan inte levereras",
  },
  orders: "Beställningar",
  notEnoughPoints: "Det finns inte tillräckligt med poäng tillgängliga.",
  statusText: "Status",
  outOfStock: "För närvarande inte i lager",
  productUnavailable: "Den här produkten är inte längre tillgänglig.",
  deletedProductsTitle: "Produkter inte längre tillgängliga",
  deletedProductsMessage: "Följande produkter är inte längre tillgängliga. Ta bort dem från varukorgen för att fortsätta.",
  removeSelected: "Ta bort valda",
  clearCart: "Töm varukorgen",
  removeSelectedConfirm: "Ta bort de valda produkterna från varukorgen?",
  clearCartConfirm: "Ta bort alla produkter från varukorgen?",
  incompleteAddress: {
    firstName: "Lägg till ett förnamn i leveransadressen",
    lastName: "Lägg till ett efternamn i leveransadressen",
    company: "Lägg till ett företagsnamn i leveransadressen",
    street: "Lägg till gata och husnummer i leveransadressen",
    postalCode: "Lägg till ett postnummer i leveransadressen",
    city: "Lägg till en ort i leveransadressen",
    country: "Lägg till ett land i leveransadressen",
    phone: "Lägg till ett telefonnummer i leveransadressen",
  },
  placeOrder: "Bindande beställning",
  toOrderDelivery: "Fortsätt till leveransadress",
  toOrderSummary: "Till orderöversikt",
  productImg: "Produktbild",
  selectAddressBtn: "Välj adress",
  perPgae: "Objekt per sida",
  categories: {
    advertising: {
      title: "Reklammaterial",
      desc: "Delta direkt här på plattformen och säkra <br/> 40 extra poäng för belöningsklubben.",
    },
    rewards: {
      title: "Exklusiva belöningar",
      desc: "Upptäck bonuserbjudandet i vårt utbildningscenter eller hos dig.",
    },
    tools: {
      title: "Verktyg för verkstad",
      desc: "Använd dina poäng för tredjepartsutbildning <br/> och minska dina kostnader.",
    },
    trainings: {
      title: "Utbildning och kurser",
      desc: "Upptäck bonuserbjudandet i vårt utbildningscenter eller hos dig.",
    },
    salesroom: {
      title: "Försäljningsrum",
      desc: "Inred försäljningsrummet och erbjud kunderna en trevlig vistelse.",
    },
    hunter: {
      title: "Hunter",
      desc: "Byt poäng mot attraktiv verkstadsutrustning från Hunter.",
    },
  },
  bestSold: "Bästsäljare",
  seasonal: "Säsong",
  affordable: "Nästan klart",
  forPoints: "för {points} poäng",
  reachedPoints: "Nödvändiga poäng uppnådda",
  remainingPoints: "{points} poäng kvar",
  favoriteProducts: {
    description: "Här hittar du de produkter du har sparat.",
  },
  categoryPageDescriptionFallback: "Material till verkstaden eller andra kvalitetsprodukter med Bridgestone-logotypen för ditt företag",
  variant: "Valbara varianter",
};
export default {
  messages,
};
